import React from 'react';
import { useLang, useT } from '../../../../i18n';
import photo from '../../../../assets/landing-couple.webp';
import { exampleDate } from './exampleDate';

const THEMES = ['#9E5462', '#56714F', '#3F5573'];

// Le site des mariés sur ordinateur et sur mobile : la couleur et la police
// changent ensemble, comme quand on personnalise son site.
const SiteVisual: React.FC = () => {
  const t = useT();
  const { lang } = useLang();
  const date = exampleDate(lang);
  return (
    <div className="mk-fv-stage mk-fv-site">
      <div className="mk-fv-box mk-fv-browser">
        <div className="mk-fv-bar">
          <i />
          <i />
          <i />
          <span>remi-estelle.please-rsvp.com</span>
        </div>
        <div className="mk-fv-desk">
          <div className="mk-fv-photo">
            <img src={photo} alt="" loading="lazy" decoding="async" />
          </div>
          <div className="mk-fv-invite">
            <span className="mk-fv-eye">{t('Invitation')}</span>
            <span className="mk-fv-names mk-fv-font">
              Rémi
              <br />
              <i>&amp;</i>
              <br />
              Estelle
            </span>
            <span className="mk-fv-tagline">{t('vous invitent à célébrer leur union')}</span>
            <span className="mk-fv-date">
              <i />
              {date}
              <i />
            </span>
            <span className="mk-fv-venue mk-fv-font">Domaine de Valbonne</span>
            <span className="mk-fv-cta">{t("Répondre à l'invitation")}</span>
          </div>
        </div>
      </div>

      <div className="mk-fv-phone">
        <div className="mk-fv-phone-screen">
          <div className="mk-fv-photo mk-fv-phone-photo">
            <img src={photo} alt="" loading="lazy" decoding="async" />
          </div>
          <div className="mk-fv-phone-main">
            <span className="mk-fv-eye">{t('Invitation')}</span>
            <span className="mk-fv-names mk-fv-font">
              Rémi <i>&amp;</i> Estelle
            </span>
            <span className="mk-fv-tagline">{t('vous invitent à célébrer leur union')}</span>
            <span className="mk-fv-venue mk-fv-font">Domaine de Valbonne</span>
          </div>
          {/* barre d'action collée en bas, comme sur le vrai site mobile */}
          <div className="mk-fv-phone-action">
            <span className="mk-fv-cta">{t("Répondre à l'invitation")}</span>
          </div>
        </div>
      </div>

      <div className="mk-fv-box mk-fv-themes">
        <span className="mk-fv-k">{t('Thème')}</span>
        <span className="mk-fv-swatches">
          {THEMES.map((c) => (
            <i key={c} style={{ background: c }} />
          ))}
          <b />
        </span>
      </div>
    </div>
  );
};

export default SiteVisual;
